import { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';
import type { StatusFilter } from 'state/quotes/dashboard/filter/filter.model';
import type { QuoteIndexableData } from 'state/quotes/dashboard/selectors';

import type { FiltersCounts } from './Filter.helper';
import { filterQuoteByStatusFilter, mapStatusFilterToIcon } from './Filter.helper';
import type { FilterFormatter } from './FilterItem';
import { FilterItem } from './FilterItem';

const availableStatus: StatusFilter[] = ['all', 'inprogress', 'completed', 'rejected'];
export interface FilterByStatusProps {
  selectedStatus: StatusFilter;
  filtersCounts: FiltersCounts;
  quotes: QuoteIndexableData[];
  onByStatusFilterChanged(filter: StatusFilter): void;
  onTilesDeleted(quoteIds: string[]): void;
}

export const FilterByStatus: FC<FilterByStatusProps> = ({
  selectedStatus,
  filtersCounts,
  quotes,
  onByStatusFilterChanged,
  onTilesDeleted,
}) => {
  const { formatMessage } = useIntl();

  const onFilterTilesDeleted = useCallback(
    (filter: StatusFilter) => {
      const quoteIdsToDelete = quotes
        .filter(quote => filterQuoteByStatusFilter(quote, filter))
        .map(quote => quote.quoteId);
      onTilesDeleted(quoteIdsToDelete);
    },
    [onTilesDeleted, quotes],
  );

  const formatFilter: FilterFormatter<StatusFilter> = useCallback(
    (filter: StatusFilter) => formatMessage({ id: `dashboard.filter.status.${filter}` }),
    [formatMessage],
  );

  return (
    <ul className="nav nav-hover nav-underline flex-column">
      {availableStatus.map(status => (
        <FilterItem
          key={status}
          filter={status}
          isActive={status === selectedStatus}
          count={filtersCounts.byStatus[status] || 0}
          e2e="filter"
          label={formatFilter}
          icon={mapStatusFilterToIcon}
          onSelected={onByStatusFilterChanged}
          onTilesDeleted={onFilterTilesDeleted}
        />
      ))}
    </ul>
  );
};

FilterByStatus.displayName = 'FilterByStatus';
